document.addEventListener("click", function (event) {
    let variantButton = event.target.closest(".product__color-swatch");
    if (!variantButton) return; // Exit if the clicked element is not a variant button

    let disValue = variantButton.getAttribute("dis");
    console.log("Clicked Variant - Discount (raw):", disValue);
    
    updateDiscount(disValue);
});

// Function to update discount elements with proper rounding
function updateDiscount(discountValue) {
    if (discountValue) {
        let numericDiscount = parseFloat(discountValue);

        if (!isNaN(numericDiscount)) {
            // Custom rounding logic
            let roundedDiscount = (numericDiscount % 1 < 0.5) 
                ? Math.floor(numericDiscount)  // If decimal part ≤ 0.5 → round down
                : Math.ceil(numericDiscount); // If decimal part > 0.5 → round up

            let discountText = `-${roundedDiscount}%`;

            // Update all <p class="pro-img-discount"> elements
            document.querySelectorAll(".pro-img-discount").forEach((p) => {
                p.textContent = discountText;
            });

            console.log("Updated Discount:", discountText);
        } else {
            console.warn("Invalid discount value:", discountValue);
        }
    }
}